export const getPrice = (price?: number, tva?: number) => price ?? 0;
// tva ? ((price ?? 0) * (1 + Number(tva ?? 0) / 100)).toFixed(2) : price;
